import { FadeUp, Overline, MaskedLines } from "@/components/Reveal";
import { TESTIMONIALS } from "@/data/site";

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-28 md:py-40">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        <FadeUp>
          <Overline>Kind Words</Overline>
        </FadeUp>
        <h2 className="mt-8 font-display font-light text-4xl md:text-5xl lg:text-7xl leading-[0.98] tracking-tight">
          <MaskedLines lines={["TRUSTED WITH", "THE DETAILS."]} />
        </h2>

        <div className="mt-16 grid md:grid-cols-3 gap-px bg-ivory/10 border hairline">
          {TESTIMONIALS.map((t, i) => (
            <FadeUp key={i} delay={0.1 * i} className="bg-ink">
              <blockquote
                data-testid={`testimonial-${i + 1}`}
                className={`p-8 md:p-10 flex flex-col h-full ${i === 1 ? "md:mt-8" : ""}`}
              >
                <span className="font-display text-6xl text-gold/30 leading-none select-none" aria-hidden="true">&ldquo;</span>
                <p className="font-display italic font-light text-xl md:text-2xl leading-relaxed text-ivory/90 flex-1 -mt-4">
                  {t.quote}
                </p>
              </blockquote>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
